// extracted by mini-css-extract-plugin
export var pageContentWrapWide = "index-module--pageContentWrapWide--0c097";
export var pageContentWrapWideWithMargin = "index-module--pageContentWrapWideWithMargin--cb78c";